import {
  FontWeight, HStack, Icon, ICON_STAR, Text, TextColor,
} from '@doveit/bricks';
import React from 'react';

export interface ShortRatingProps extends React.AriaAttributes {
  score: number,
}

const ShortRating: React.FC<ShortRatingProps> = ({
  score,
  ...rest
}) => {
  const color: TextColor = React.useMemo(() => {
    if (score < 3) return 'critical.default.low';
    if (score < 4) return 'warning.default.low';

    return 'success.default.low';
  }, [score]);

  return (
    <HStack
      gap={25}
      wrap="nowrap"
      {...rest}
    >
      <Text.BodySmall
        fontWeight={FontWeight.MEDIUM}
        color={color}
      >
        {score}
      </Text.BodySmall>
      <Icon
        path={ICON_STAR}
        color={color}
        size={16}
      />
    </HStack>
  );
};

export default ShortRating;
